/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable array-callback-return */
import React from "react";

function Portfolio({ data }) {
  // Pdhouse
  if (data) {
    var PdHouse = data.PdHouse.map(function (PdHouse) {
      return (
        <div key={PdHouse.title} className="columns portfolio-item">
          <div className="item-wrap">
              <img alt={PdHouse.title} src={`${PdHouse.image}`} />
              <div className="overlay">
                <div className="portfolio-item-meta">
                  <h5>{PdHouse.title}</h5>
                </div>
              </div>
          </div>
        </div>
      );
    });
  }

  // Agency
  if (data) {
    var Agency = data.Agency.map(function (Agency) {
      return (
        <div key={Agency.title} className="columns portfolio-item">
          <div className="item-wrap">
            <img alt={Agency.title} src={`${Agency.image}`} />
            <div className="overlay">
              <div className="portfolio-item-meta">
                <h5>{Agency.title}</h5>
              </div>
            </div>
          </div>
        </div>
      );
    });
  }

  // Directors
  if (data) {
    var Directors = data.Directors.map(function (Directors) {
      return (
        <div key={Directors.title} className="columns portfolio-item">
          <div className="D-Comp">
            <img src={Directors.image} alt="" className="DImg" />
            <h3>{Directors.title}</h3>
          </div>
        </div>
      );
    });
  }

  // Brand - WebShows
  if (data) {
    var WebShows = data.WebShow.map(function (WebShows) {
      return (
        <div key={WebShows.title} className="columns portfolio-item">
          <div className="item-wrap">
            <a href={WebShows.url} title={WebShows.title} target="_blank">
              <img alt={WebShows.title} src={`${WebShows.image}`} />
              <div className="overlay">
                <div className="portfolio-item-meta">
                  <h5>{WebShows.title}</h5>
                  <p>{WebShows.description}</p>
                </div>
              </div>
            </a>
          </div>
        </div>
      );
    });
  }

  return (
    <section id="portfolio">
      <div className="row">
        {/* Webshows */}
        <div className="WebS">
          <h2>Web / Tv Shows</h2>
          <div className="grid-wrapper">{WebShows}</div>
        </div>
        <h1>Our Notable Collaborations</h1>
        <div className="Agency">
          <h2>Agencies</h2>
          <div className="grid-wrapper">{Agency}</div>
        </div>
        <div className="PdHouse">
          <h2>Production Houses</h2>
          <div className="grid-wrapper">{PdHouse}</div>
        </div>
        <div className="Directors">
          <h2>Directors</h2>
          <div className="grid-wrapperD">{Directors}</div>
        </div>
      </div>
    </section>
  );
}

export default Portfolio;
